<template>
    <router-link :to="toRoute" :class="[type, {active : !getCurrentProvider}]">
        <div class="title" @click.self="setProvider(null)" :class="[{'day-active' : !getCurrentProvider && $route.path.includes(toRoute)}]">
            <i :class="['el-icon-arrow-right expand-icon', { open: openProviderList }]" @click="expandProviderList"></i>
            <!-- Slot for title of the provider expand -->
            <span @click="setProvider(null)" :class="{ zero : totalCount == 0 }">{{ totalCount }}</span>
            <slot></slot>
        </div>
        <transition name="expand">
            <ul class="provider-list" v-if="openProviderList && type === 'upcoming'">
                <li v-for="(provObj) in getProvidersListForExpandedDay"
                    :key="day+'-'+provObj.provKey"
                    :class="['event-content-list', {active_provid : getCurrentProvider === provObj.provKey && $route.path.includes(toRoute)}]"
                    @click="setProvider(provObj.provKey)">
                    <EventExpand :eventwise-patient-count-for-duration="provObj.patientCnt"
                        :total-count="provObj.patientCnt.length"
                        :sel-provider="provObj.provKey"
                        :to-route="eventToRoute"
                        :curr-event="currEvent"
                        :day="day"
                        @set-curr-event="setCurrEvent"
                        type="event">
                        {{ getSlicedName(getProviderNameById(provObj.provKey)) }}
                    </EventExpand>
                </li>
            </ul>
            <ul class="provider-list" v-if="openProviderList && type !== 'upcoming'">
                <li v-for="provObj in getProvidersListForExpandedDay"
                    :key="provObj.provKey"
                    :class="{active : getCurrentProvider === provObj.provKey && $route.path.includes(toRoute)}"
                    @click="setProvider(provObj.provKey)">
                    <el-tooltip :disabled="provObj.provName.length < 19" :content="provObj.provName" placement="bottom" effect="dark" :open-delay="1000">
                        <span class="provider-name">
                            {{ getSlicedName(provObj.provName) }} <span class="provider-code" v-if="getUserType === 'observer'">({{ this.getProviderList().find(prov => prov.provider === provObj.provKey).code }})</span>
                        </span>
                    </el-tooltip>
                    
                    <span class="provider-patients">{{ provObj.patientCnt }}</span>
                </li>
            </ul>
        </transition>
        <ul class="provider-choosen" v-if="showProviderOnClose && type !== 'upcoming'" :style="getUserType === 'observer' ? 'backgroundColor: #1B98CD' : ''">
            <li>
                <el-tooltip :disabled="provider.name.length < 19" :content="provider.name" placement="bottom" effect="dark" :open-delay="1000">
                    <span class="provider-name">
                        {{ getSlicedName(getProvider.name) }} <span class="provider-code" v-if="getUserType === 'observer'">({{ provider.code }})</span>
                    </span>
                </el-tooltip>
                
                <span>{{ providerwisePatientCount[getCurrentProvider] }}</span>
            </li>
        </ul>
        <ul class="provider-list" v-if="showProviderOnCloseForUpcoming && type === 'upcoming'" :style="getUserType === 'observer' ? 'backgroundColor: #1B98CD' : ''">
            <li :key="day+'-'+getCurrentProvider"
                :class="['event-content-list', { active_provid : $route.path.includes(toRoute)} ]"
                @click="setProvider(getCurrentProvider)">
                <EventExpand :eventwise-patient-count-for-duration="providerwisePatientCount[getCurrentProvider]"
                    :total-count="providerwisePatientCount[getCurrentProvider].length"
                    :sel-provider="getCurrentProvider"
                    :to-route="eventToRoute"
                    :curr-event="currEvent"
                    :day="day"
                    @set-curr-event="setCurrEvent"
                    type="event">
                    {{ getSlicedName(getProviderNameById(getCurrentProvider)) }}
                </EventExpand>
            </li>
        </ul>
    </router-link>
</template>

<script>
import provider from '@/store/module/provider'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import SidebarList from '.'
import EventExpand from './EventExpand'


/**
 * Expanding component to give a list of
 * providers to be reused for expanding and contracting
 * provider list for different components of the sidebar
 */
export default {
    name: 'provider-expand',
    extends: SidebarList,

    props: {
        providerwisePatientCount: {
            type: Object,
            required: true,
            default: () => ({})
        },
        totalCount: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'patients'
        },
        toRoute: {
            type: String,
            default: '/patient'
        },
        day: {
            type: String,
            // default: 'today'
        },
    },

    data() {
        return {
            openProviderList: false,
            currEvent: null,
        }
    },

    methods: {
        ...mapActions('provider', [
            'setCurrentProvider',
        ]),
        expandProviderList(event) {
            this.openProviderList = !this.openProviderList
            event.preventDefault()
        },
        setProvider(provider) {
            this.currEvent = null
            if(provider) {
                this.setCurrentProvider(provider)
                if(this.type === 'upcoming') {
                    this.$router.push({ path: '/upcoming/' + this.day}).catch(()=>{})
                }
            }
            else
                this.setCurrentProvider(null)
        },
        getSlicedName(name) {
            const sliced = name && name.slice(0, 18)
            if(name && name.length > 18)
                return sliced + '...'
            return sliced
        },
        eventwisePatientCount(day) {
            let tempObj = {}

            if(this.overview && 
                this.overview.schedule && 
                this.overview.schedule[day] && 
                Object.keys(this.overview.schedule[day]).length > 0) {
                    this.totalCount[day] = this.findPatientWiseCntForDayProvider(this.overview.schedule[day])
                    return this.overview.schedule[day]
                    // Object.entries(this.overview.schedule[day]).forEach((provWisePat) => {
                    //     if(provWisePat[1].length > 0) tempObj[provWisePat[0]] = provWisePat[1]
                    // })
            }

            // this.totalCount[day] = this.findPatientWiseCntForDay(tempObj)
            // return tempObj
        },
        findPatientWiseCntForDayProvider(provWisePatient) {
            let res = Object.values(provWisePatient).reduce((acc, curr) => {
                acc += curr.length
                return acc
            }, 0)
            return res
        },
        setCurrEvent(evnt) {
            this.currEvent = evnt
        },
        findUniqEventForDayProv (eventsListForDayProv) {
            let upcomingMappedSchedule = this.overview && this.overview.schedule_map

            return eventsListForDayProv.length > 0 && eventsListForDayProv.reduce((acc,curr) => {
                let eventObj = upcomingMappedSchedule[curr]
                if(!acc.includes(eventObj.event)) acc.push(eventObj.event)
                return acc
            }, []).length
        }
    },

    computed: {
        ...mapState('provider', [
            'overview'
        ]),
        ...mapGetters('provider', [
            'getCurrentProvider',
            'getProvider',
            'getProviderPatientList',
            'getProviderNameById'
        ]),
        ...mapGetters(['getUserType']),
        eventToRoute() {
            if(this.currEvent)
                return '/upcoming/' + this.day + '/' + this.currEvent
            else return '/upcoming/' + this.day
        },
        showProviderOnClose() {
            return this.getProvider && !this.openProviderList && this.$route.path.includes(this.toRoute) 
                && !(this.$route.path.includes('add/patient') || this.$route.path.includes('imports'))
        },
        showProviderOnCloseForUpcoming() {
            return this.getProvider && !this.openProviderList && this.$route.path.includes(this.toRoute) 
                && !(this.$route.path.includes('add/patient') || this.$route.path.includes('imports'))
        },
        getProvidersListForExpandedDay() {
            return Object.entries(this.providerwisePatientCount).map(prov => 
                    ({
                        provKey: prov[0],
                        provName: this.getProviderNameById(prov[0]),
                        patientCnt: prov[1]
                    })
                )
                .filter(({ provKey }) => provKey !== 'total')
                .sort((a,b) => {
                    const nameA = a.provName.toUpperCase().replace('DR. ', '')
                    const nameB = b.provName.toUpperCase().replace('DR. ', '')
                    return (nameA > nameB ? 1 : ((nameB > nameA ? -1 : 0)))
                })
        },
        setMaxHeight() {
            let len = this.getProvidersListForExpandedDay.reduce((acc,curr) => {
                acc += 1 + this.findUniqEventForDayProv(curr.patientCnt)
                return acc
            }, 0)
            return ((len * 28) + 100).toString() + 'px'
        }
    },

    components: {
        EventExpand
    }
    
}
</script>

<style lang="scss" scoped>
@import "style.scss";
ul > li > a ul.provider-list > li.active, 
ul > li > a ul.provider-list > li.active:hover {
    // background-color: #1B98CD;
}
.provider-code {
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    float: left;
}
</style>
